export interface LeaveTypeItem {
    code: number; 
    name: string;
}

export interface LeaveTypesOptions {
    group: string;
    items: LeaveTypeItem[]
}

export class LeaveTypesSubGroup {
    leaveTypes: LeaveTypesOptions[] = [
        {
            group: 'Involuntário',
            items: [
                { code: 14, name: 'Baixa Performance' },
                { code: 6, name: 'Fim de Contrato' },
                { code: 7, name: 'Outros' },
                { code: 8, name: 'Perfil incompatibilizado' },
                { code: 9, name: 'Postura (Comportamento, ética e similares)' },
                { code: 10, name: 'Reestruturação' },
                { code: 1, name: 'Solicitação do Cliente' },
            ]
        },
        {
            group: 'Voluntário',
            items: [
                { code: 11, name: 'Insatisfeito com o Cliente/Projeto' },
                { code: 12, name: 'Oportunidade Internacional' },
                { code: 13, name: 'Proposta Nacional (Desafio)' },
                { code: 2, name: 'Proposta Nacional (Remuneração/CLT)' },
                { code: 3, name: 'Questões Pessoais' }
            ]
        }
    ]
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/LeaveTypes.enum.ts